// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__PwPA8","empty":"ModalGraph_empty__Wjny0"};